import { render, staticRenderFns } from "./XeroLinkAccount.vue?vue&type=template&id=10ec387f&scoped=true&"
import script from "./XeroLinkAccount.vue?vue&type=script&lang=ts&"
export * from "./XeroLinkAccount.vue?vue&type=script&lang=ts&"
import style0 from "./XeroLinkAccount.vue?vue&type=style&index=0&id=10ec387f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ec387f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VIcon,VTextField})
